import registerServiceWorker from './registerServiceWorker';
import { fetchUser } from './actions';
import routes from './routes';
import reducers from './reducers';
import './style.css';
import './cult.css';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import { Router, browserHistory } from 'react-router';

const createStoreWithMiddleware = applyMiddleware(thunk)(createStore);
const store = createStoreWithMiddleware(reducers, window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__());
//const store = createStoreWithMiddleware(reducers);
const token = localStorage.getItem('token');

// If a token exists, consider the user signed in
(function() {
  if (token) {
    fetchUser(store);
  }

ReactDOM.render(
  <Provider store={store}>
    <Router history={browserHistory} routes={routes} />
  </Provider>,
  document.getElementById('root'));
  registerServiceWorker();
})();



// WEBPACK FOOTER //
// ./src/index.js